
import HeroBanner from './CareerComponents/HeroBanner';
import AboutSection from './CareerComponents/AboutSection';
import ChallengeBoard from './CareerComponents/ChallengeBoard';
import BenefitsSection from './CareerComponents/BenefitsSection';
import TeamSection from './CareerComponents/TeamSection';
// import Footer from './CareerComponents/Footer';
import RoleCard from './CareerComponents/RoleCard';
import JoinSection from './CareerComponents/JoinSection';
import './CareersPage.css';
import { useState, useEffect } from 'react';

export default function CareersPage() {  // Renamed from Home to CareersPage
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        // Use environment variable for API base URL
        console.log("fetching roles");
        const response = await fetch(`https://pp-backend-1-sa8p.onrender.com/api/careers/roles`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setRoles(data);
        setError(null);
      } catch (error) {
        console.error('Fetch error:', error);
        setError('Failed to load roles. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
  
    fetchRoles();
  }, [])
  // const roles = [
  //   {
  //     id: 1,
  //     title: "Property Consultant",
  //     location: "Pan India",
  //     type: "Freelance-to-Full-Time",
  //     overview: "At Property Plateau Realty, a Property Consultant doesn't join with a paper, they join with a closure.",
  //     responsibilities: [
  //       "Lead Conversion – Engage, nurture, and convert leads",
  //       "Deal Closure – Bring 1 successful deal within 60 days",
  //       "Market Mastery – Understand and own your region/locality"
  //     ],
  //     qualifications: [
  //       "Hustlers who love real estate, human psychology, and big rewards",
  //       "Students, job seekers, part-timers who want to transition"
  //     ]
  //   },{
  //     id: 2,
  //     title: "Builder Relations Associate",
  //     location: "Pan India (Hybrid + Field Role)",
  //     type: "Builder & Supply Partnerships",
  //     overview: ["At Property Plateau Realty, we believe that strong supply-side relationships are the backbone of real estate success. The Builder Relations Associate is the driving force behind our inventory quality, exclusivity, and first-mover advantage in new launches and off-market properties.",
  //       "In this role, you won’t just build connections — you’ll build strategic partnerships that power the next generation of real estate experiences across India."
  //     ],
  //     responsibilities: [
  //       "Builder Onboarding-Identify, approach, and onboard reputed builders, developers, and construction firms.",
  //       "Partnership Management-Negotiate and finalize partnership terms, MOUs, or exclusivity arrangements.",
  //       "Inventory Management-Collect accurate, real-time inventory details: availability, pricing, offers, payment plans.",
  //       "Relationship Nurturing-Develop and maintain long-term, trust-based relationships with builders and key decision-makers.",
  //       "Market Intelligence-Keep track of upcoming launches, land acquisitions, RERA updates, and new trends.",
  //       "Internal Collaboration-Act as a bridge between the supply side and sales/consultant teams.",
        
  //     ],
  //     qualifications: [
  //       "Bachelor's degree in Business, Marketing, Real Estate, or related field.",
  //       "1–4 years of experience in builder relations, channel sales, or real estate partnerships.",
  //       "Excellent communication, negotiation, and interpersonal skills.",
  //       "Strong local market knowledge and ability to travel for site visits and builder meetings.",
  //       "CRM and reporting tools experience is a plus.",
  //       "Proactive, dependable, and driven by relationships and results."
  //     ]
  //   },
  //   // ... other roles
  // ];
  if (loading) return <div className="loading">Loading roles...</div>;

  return (
    <div className="careers-page">
      <>
        <title>Property Plateau Realty | Careers</title>
        <meta name="description" content="Join the real estate revolution" />
      </>

      <HeroBanner />
      
      <main>
        
        <AboutSection />
        
        <ChallengeBoard />
        
        <section className="roles-section">
          <h2>Current Opportunities</h2>
          <div className="roles-container">
            {roles.map(role => (
              <RoleCard key={role.id} role={role} />
            ))}
          </div>
        </section>
        
        <BenefitsSection />
        
        <TeamSection />
      </main>

      <JoinSection/>
    </div>
  );
}